import { createAppRequest } from '../request';
import type { ApiResponse, InvestorItem, PageResult } from './startup.api';

const appRequest = createAppRequest();

export type InvestorQuery = {
  pageNumber?: number;
  pageSize?: number;
  keyword?: string;
  industry?: string;
  fundingStage?: string;
  enabled?: boolean;
  includeDisabled?: boolean;
  investmentAmount?: string;
};

export type InvestorPayload = {
  name: string;
  description?: string;
  industries?: string[];
  fundingStages?: string[];
  minInvestment?: string;
  maxInvestment?: string;
  regions?: string[];
  focusKeywords?: string[];
  enabled?: boolean;
};

export async function getInvestors(
  params?: InvestorQuery,
): Promise<ApiResponse<PageResult<InvestorItem>>> {
  return appRequest('/bff/investors', {
    method: 'GET',
    params,
  });
}

export async function getInvestorDetail(
  uuid: string,
): Promise<ApiResponse<InvestorItem>> {
  return appRequest(`/bff/investors/${uuid}`, {
    method: 'GET',
  });
}

export async function createInvestor(
  data: InvestorPayload,
): Promise<ApiResponse<InvestorItem>> {
  return appRequest('/bff/investors', {
    method: 'POST',
    data,
  });
}

export async function updateInvestor(
  uuid: string,
  data: Partial<InvestorPayload>,
): Promise<ApiResponse<InvestorItem>> {
  return appRequest(`/bff/investors/${uuid}`, {
    method: 'PATCH',
    data,
  });
}

export async function enableInvestor(
  uuid: string,
): Promise<ApiResponse<InvestorItem>> {
  return appRequest(`/bff/investors/${uuid}/enable`, {
    method: 'POST',
  });
}

export async function disableInvestor(
  uuid: string,
): Promise<ApiResponse<InvestorItem>> {
  return appRequest(`/bff/investors/${uuid}/disable`, {
    method: 'POST',
  });
}
